const SELECTORS = Selectors({
    masonryLayout: '.masonary-layout',
    masonryLayoutNoGridWidth: '.masonary-layout-no-grid-width',
});

const $masonryLayout = document.querySelectorAll(SELECTORS.masonryLayout);
const $masonryLayoutNoGridWidth = document.querySelectorAll(SELECTORS.masonryLayoutNoGridWidth);

const fn = {
    init: () => {
        $(document).ready(() => {
            if ($(SELECTORS.masonryLayout).length) {
                $(SELECTORS.masonryLayout).isotope({
                    layoutMode: 'masonry',
                    itemSelector: '.masonary-item',
                });
            }
            if ($(SELECTORS.masonryLayoutNoGridWidth).length) {
                $(SELECTORS.masonryLayoutNoGridWidth).isotope({
                    layoutMode: 'masonry',
                    itemSelector: '.masonary-item',
                });
            }
        });
    },
};

export default {
    can: () => $masonryLayout.length || $masonryLayoutNoGridWidth.length,
    run: fn.init,
};
